import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { Form } from "react-final-form";
import * as qs from "query-string";
import AppBar from "../../Components/header/AuthenticationPageHeader";
import AppProvider from "../../Components/bootstrap/index";
import { FeedbackForm } from "./FeedbackForm";
import Parse from "parse";
import { useDispatch } from "react-redux";
import {
  useAuthenticated,
  useNotify,
  fetchEnd,
  fetchStart,
  useRedirect,
} from "react-admin";

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: 10,
    width: 300,
    height: 60,
    // margin: theme.spacing(1),
    backgroundColor: "white",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  coverBackgroundContainer: {
    backgroundColor: "#F7F8F9",
    height: "100%",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "4%",
    paddingRight: "4%",
    paddingTop: "90px",
    paddingBottom: "20px",
  },
}));

const Feedback = (props) => {
  const classes = useStyles();
  const parsed = qs.parse(props.location.search);
  const notify = useNotify();
  const redirectTo = useRedirect();
  const dispatch = useDispatch();
  useAuthenticated();
  return (
    <div className={classes.coverBackgroundContainer}>
      <AppProvider>
        <Container
          component="main"
          maxWidth="sm"
          style={{ background: "#ffffff", marginBottom: "2%" }}
        >
          <AppBar />
          <Typography component="h6" variant="h6" style={{ paddingTop: "10%" }}>
            Give Your Feedback
          </Typography>

          <Form
            initialValues={{}}
            onSubmit={async (response) => {
              try {
                dispatch(fetchStart());
                const ZoomFeedback = await Parse.Cloud.run("AddZoomFeedback", {
                  values: response,
                  params: parsed,
                });

                if (ZoomFeedback) {
                  notify("Feedback Submited");
                  dispatch(fetchEnd());
                  redirectTo("/");
                } else {
                  notify("Feedback Submited");
                  dispatch(fetchEnd());
                  redirectTo("/");
                }
              } catch (e) {
                notify(e.message);
              } finally {
                dispatch(fetchEnd());
              }
            }}
            keepDirtyOnReinitialize
            render={FeedbackForm}
          />
        </Container>
      </AppProvider>
    </div>
  );
};
export default Feedback;
